(function() {
  'use strict';
  
  // Product Growth Modal Handler
  class ProductGrowthModal {
    constructor() {
      this.modal = null;
      this.modalData = null;
      this.isInitialized = false;
      this.init();
    }
    
    init() {
      // Wait for DOM to be ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup());
      } else {
        this.setup();
      }
    }
    
    setup() {
      if (this.isInitialized) return;
      
      // Get modal data from JSON
      const dataElement = document.getElementById('product-growth-modal-data');
      if (!dataElement) {
        console.warn('Product Growth Modal: No data found');
        return;
      }
      
      try {
        this.modalData = JSON.parse(dataElement.textContent);
      } catch (e) {
        console.error('Product Growth Modal: Invalid JSON data', e);
        return;
      }
      
      // Get modal element
      this.modal = document.getElementById('product-growth-modal');
      if (!this.modal) {
        console.warn('Product Growth Modal: Modal element not found');
        return;
      }
      
      this.bindEvents();
      this.isInitialized = true;
    }
    
    bindEvents() {
      // Bind click events to cultivo items
      document.addEventListener('click', (e) => {
        const cultivoItem = e.target.closest('.cultivo-item');
        if (cultivoItem) {
          e.preventDefault();
          this.openModal(cultivoItem);
        }
      });
      
      // Bind close events
      const closeButtons = this.modal.querySelectorAll('[data-close-product-growth-modal]');
      closeButtons.forEach(btn => {
        btn.addEventListener('click', () => this.closeModal());
      });
      
      // Close on overlay click
      const overlay = this.modal.querySelector('.product-growth-modal__overlay');
      if (overlay) {
        overlay.addEventListener('click', () => this.closeModal());
      }
      
      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.closeModal();
        }
      });
    }
    
    openModal(cultivoItem) {
      const modalKey = cultivoItem.dataset.modal;
      if (!modalKey || !this.modalData[modalKey]) {
        console.warn('Product Growth Modal: Invalid modal key', modalKey);
        return;
      }
      
      const data = this.modalData[modalKey];
      const title = this.modal.querySelector('.product-growth-modal__title');
      const text = this.modal.querySelector('.product-growth-modal__text');
      
      if (title) title.textContent = data.title;
      if (text) text.innerHTML = data.text; // Use innerHTML for rich text
      
      this.modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      // Focus management
      const closeBtn = this.modal.querySelector('[data-close-product-growth-modal]');
      if (closeBtn) closeBtn.focus();
    }

    closeModal() {
      this.modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    isOpen() {
      return this.modal && this.modal.classList.contains('is-open');
    }
  }
  
  // Initialize the modal
  new ProductGrowthModal();
})(); 